/* eslint-disable no-console */
import 'reflect-metadata';
import { TextField } from '../demo-lib/text-field.js';
import { Text } from '../demo-lib/text.js';
import { Button } from '../demo/button.js';
import { view } from '../factory.js';
import {
  useEffect,
  useEnvironmentObject,
  useSharableState,
} from '../hooks/index.js';
import { HSTack } from '../layout/hstack.js';
import { VSTack } from '../layout/vstack.js';
import { Story } from '../view-demoing.js';
import { ObservableObject, observableValue } from './observable-value.js';
import { numberFormatter } from '../formatters/number.js';
import { datetimeFormatter } from '../formatters/datetime.js';
import { Lazy } from '../decorators/lazy.js';
import { isoDateParserFormatter } from '../formatters/date.js';

export default {
  title: 'Shared State / ObservableValue',
};

class Person extends ObservableObject {
  readonly firstname = observableValue('Jonatan');
  readonly lastname = observableValue('');
  readonly birthdate = observableValue(new Date('1988-10-07'));

  @Lazy()
  get age() {
    return this.birthdate.map(date => {
      const today = new Date();
      let yearDiff = today.getFullYear() - date.getFullYear();
      const monthDiff = today.getMonth() - date.getMonth();
      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < date.getDate())
      ) {
        yearDiff -= 1;
      }
      return yearDiff;
    });
  }

  static get default() {
    return new Person();
  }
}

const [PersonView] = view('esui-demo-observable-object', {
  Props: class {},
  template() {
    const person = useEnvironmentObject(Person, Person.default);

    return HSTack(
      Text(person.firstname),
      Text(person.lastname),
      Text(person.age, numberFormatter()),
      Text('years old.'),
      Text('Born on'),
      Text(person.birthdate, datetimeFormatter({ dateStyle: 'full' }))
    );
  },
});

const [PersonForm] = view('esui-demo-observable-update', {
  Props: class {},

  template() {
    const person = useEnvironmentObject(Person, Person.default);
    const sharedName = useSharableState('');

    useEffect(() => {
      setTimeout(() => {
        person.firstname.value = 'JonSom';
        sharedName.value = 'Hello World!';
      }, 1000);
    }, [person]);

    return HSTack(
      TextField(person.firstname),
      TextField(person.lastname),
      TextField(person.birthdate, isoDateParserFormatter()),
      TextField(sharedName),

      Button('print').onClick(() => {
        console.log(
          person.firstname.value,
          person.lastname.value,
          person.age.value
        );
      })
    );
  },
});

const story: Story<any> = () => {
  const person = new Person();

  return VSTack(PersonView(), PersonForm(), PersonForm()).environmentObject(
    person
  ).body;
};

export const Default = story.bind({});
